<template>
    <div :class="['partner-icons', classHandler]">
        <div
            class="icon-wrapper"
            v-for="(icon, i) in partnerIconsHandler"
            :key="icon.name + '_icon-' + i"
            :style="{ width: iconSize, height: iconSize }"
            @click="
                $emit('clickout-check', 'partner_row-partner_icon-' + icon.name)
            "
        >
            <slot></slot>
            <!-- slot for click-out link -->

            <base-image
                loadLazy
                :img-source="icon.url"
                :width="iconSize"
                :height="iconSize"
                :color="iconColor"
                quality="100"
                :alt="icon.name"
            />
            <!--            <span :style="{ color: labelColor, whiteSpace: whiteSpace }">{{
                $t(icon.name)
            }}</span>-->
            <div class="tooltip">{{ $t(icon.name) }}</div>
        </div>

        <div
            class="additional-icons-count"
            v-if="shouldTruncate && !showAllIcons"
            :style="{ color: iconColor }"
            @click="$emit('expand-row'), (toggleIcons = !toggleIcons)"
        >
            <div
                class="counter"
                :style="{
                    width: iconSize,
                    height: iconSize,
                    fontSize: `calc(${iconSize} / 2)`,
                }"
            >
                <span
                    >+{{
                        partnerIcons.length - partnerIconsHandler.length
                    }}</span
                >
            </div>
            <span>{{ $t('More') }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PartnerIcons',
    components: {
        BaseImage: () => import('@atoms/Image/BaseImage'),
    },
    props: {
        partnerIcons: {
            type: Array,
        },
        iconSize: {
            type: String,
            default: '32px',
        },
        iconColor: {
            type: String,
            default: '#333',
        },
        toggleAllIcons: {
            type: Boolean,
            default: false,
        },
        maxIconsMobile: {
            type: Number,
            default: 3,
        },
        maxIconsDesktop: {
            type: Number,
            default: 6,
        },
        wrapOnExpand: {
            type: Boolean,
            default: false,
        },
        labelColor: {
            type: String,
            default: '#8c8c8c',
        },
        whiteSpace: {
            type: String,
            default: 'nowrap',
        },
        isRowGamma: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            toggleIcons: false,
        };
    },
    computed: {
        classHandler() {
            return [
                this.wrapOnExpand ? 'wrap-on-expand' : '',
                this.showAllIcons ? 'toggle-all-icons' : '',
                this.isRowGamma ? 'icons-gamma' : '',
            ];
        },
        numberIconsShow() {
            return ['mobileSmall', 'mobile'].includes(this.$mq)
                ? this.maxIconsMobile
                : this.maxIconsDesktop;
        },
        shouldTruncate() {
            return this.partnerIcons.length - this.numberIconsShow > 1;
        },
        partnerIconsHandler() {
            if (this.shouldTruncate && !this.showAllIcons) {
                return this.partnerIcons.slice(0, this.numberIconsShow);
            }
            return this.partnerIcons;
        },
        showAllIcons() {
            return this.toggleAllIcons || this.toggleIcons;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/sass/mixins';

.partner-icons {
    display: flex;
    gap: 5px;
    overflow: visible;
    transition: column-gap 0.2s ease;

    .icon-wrapper,
    .additional-icons-count {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        cursor: pointer;
        flex-shrink: 0;
        overflow: visible;
        z-index: 1;

        &:hover {
            z-index: 50;

            .tooltip {
                display: block;
                opacity: 1;
                transform: translateX(-50%) translateY(-4px) scale(1);
            }
        }

        .partner-icon_link-wrapper {
            position: absolute;
            inset: 0;
            width: 100%;
            height: 100%;
            z-index: 1;
        }

        > img,
        > picture,
        > .base-image {
            position: relative;
            z-index: 2;
        }

        > span {
            font-size: 8px;
            padding-top: 5px;
            text-align: center;
            white-space: normal;
            word-break: break-word;
        }

        .tooltip {
            display: none;
            position: absolute;
            left: 50%;
            bottom: calc(100% + 8px);
            z-index: 9999;

            opacity: 0;
            pointer-events: none;

            transform: translateX(-50%) translateY(10px) scale(0.8);
            transform-origin: bottom center;
            transition: opacity 0.15s ease, transform 0.15s ease;

            background: rgba(0, 0, 0, 0.9);
            color: #fff;
            font-size: 12px;
            line-height: 1.2;
            padding: 8px;
            border-radius: 8px;
            text-align: center;

            min-width: 100px;
            max-width: 200px;
            white-space: nowrap;

            &:after {
                content: '';
                position: absolute;
                bottom: -5px;
                left: 50%;
                transform: translateX(-50%);

                border-left: 10px solid transparent;
                border-right: 10px solid transparent;
                border-top: 10px solid #000;
            }
        }
    }

    .additional-icons-count {
        user-select: none;

        .counter {
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid currentColor;
            border-radius: 50%;
        }
    }

    &.icons-gamma {
        .icon-wrapper,
        .additional-icons-count {
            .tooltip {
                bottom: calc(100% - 7px);
            }
        }
    }
}

.partner-icons.toggle-all-icons {
    flex-wrap: wrap;
    width: 100%;
    row-gap: 12px;
}

.partner-icons.wrap-on-expand {
    flex-wrap: wrap;
}
</style>
